/**
 * The Header to render for mobile devices.
 *
 * @author Dapeng Zhang
 * @version 1.0.0
 * @Date 4 Dec 2019
 */

import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import Alert from '../../../components/GlobalButtons/AlertButton';
import LogOut from '../../../components/GlobalButtons/LogOutBotton';
import { formatRoute } from '../../../utilities/Functions/FormatWords';

interface Props extends RouteComponentProps<any>{
  location: any;
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: black;
  display: flex;
`;

const Item = styled.div`
  flex: 0 0 33.33%;
  text-align: center;
  margin: auto;
  
  *{
    color: white;
    font-size: 2rem;
    margin: auto;
  }
  
  a{
    text-decoration: none;
    
    &:hover{
        text-decoration: none;
    }

    &:focus{
      color: $text-color-light;
    }
  }
`;

const Title = styled.div`
  font-size: 1.2rem;
  white-space: nowrap;
`;

const MobileHeader = (props: Props) => {
  const { location } = props;
  const { pathname } = location;
  return (
    <Wrapper>
      <Item>
        <Alert />
      </Item>
      <Item>
        <Title>
          {
            pathname
              ? formatRoute(pathname)
              : 'iTrazo'
          }
        </Title>
      </Item>
      <Item>
        <LogOut />
      </Item>
    </Wrapper>
  );
};

export default withRouter(MobileHeader);
